import { Injectable, signal } from '@angular/core';

@Injectable()
export class SalesPromotionQueryService {
  showAll = signal(false);
  activePromotionsOnly = signal(true);
}
